/**
 * LocalStorageService wraps up window.localStorage object.
 */
import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
  public static namespace: string = 'global/';

  public static getItem(
    key: string,
    namespace: string = LocalStorageService.namespace,
  ): string {
    let value;
    try {
      value = localStorage.getItem(namespace + key);
    } catch (e) {}

    return value ? JSON.parse(value) : null;
  }

  /**
   * Storage getter.
   * @param {string} key - property name.
   * @return Parsed data.
   */
  public getItem(key: any): any {
    const namespace = LocalStorageService.namespace;

    return LocalStorageService.getItem(key, namespace);
  }
  /**
   * Storage setter.
   * @param {string} key - property name.
   * @param {string} value - property value.
   * @return Parsed data.
   */
  public setItem(key: any, value: any): any {
    const namespace = LocalStorageService.namespace;
    const data = JSON.stringify(value);
    let result = null;
    try {
      localStorage.setItem(namespace + key, data);
      result = JSON.parse(data);
    } catch (e) {}

    return result;
  }
  /**
   * Remove item from storage by property name.
   * @param {string} key - property name.
   */
  public removeItem(key: any): void {
    const namespace = LocalStorageService.namespace;
    try {
      localStorage.removeItem(namespace + key);
    } catch (e) {}
  }
}
